import { IconProps } from "ztypes/icon-props";

const IconRocket3: React.FunctionComponent<IconProps> = (props) => {
  return (
    <svg
      className={props.className}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Launch Rocket 4">
        <path
          id="Vector"
          d="M15.1288 18.6812L9.31787 12.8703L16.7817 5.4064C17.7578 4.42993 18.9866 3.74461 20.3303 3.42727C21.674 3.10994 23.0795 3.17312 24.3893 3.60973C24.826 4.91954 24.8891 6.32508 24.5718 7.66878C24.2545 9.01248 23.5691 10.2412 22.5927 11.2173L15.1288 18.6812Z"
          stroke="#0068FF"
          strokeWidth="1.54"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_2"
          d="M19.4901 9.60991C20.0977 9.60991 20.5901 9.11743 20.5901 8.50991C20.5901 7.9024 20.0977 7.40991 19.4901 7.40991C18.8826 7.40991 18.3901 7.9024 18.3901 8.50991C18.3901 9.11743 18.8826 9.60991 19.4901 9.60991Z"
          fill="#0068FF"
        />
        <path
          id="Vector_3"
          d="M11.4929 19.4101L8.5874 16.5046L10.0453 13.5991L14.3983 17.9522L11.4929 19.4101Z"
          stroke="#0068FF"
          strokeWidth="1.54"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_4"
          d="M18.0327 15.7805C18.4141 16.1619 18.7165 16.6146 18.9229 17.1128C19.1293 17.6111 19.2355 18.1451 19.2355 18.6844C19.2355 19.2237 19.1293 19.7577 18.9229 20.2559C18.7165 20.7542 18.4141 21.2069 18.0327 21.5882L15.8548 23.7661C15.0847 22.996 14.652 21.9514 14.652 20.8623C14.652 19.7731 15.0847 18.7286 15.8548 17.9584L18.0327 15.7805Z"
          stroke="#0068FF"
          strokeWidth="1.54"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_5"
          d="M4.23824 12.155L6.41613 9.9771C7.18628 9.20695 8.23082 8.77428 9.31998 8.77428C10.4091 8.77428 11.4537 9.20695 12.2238 9.9771L10.0459 12.155C9.27579 12.9251 8.23125 13.3578 7.14209 13.3578C6.05293 13.3578 5.00839 12.9251 4.23824 12.155Z"
          stroke="#0068FF"
          strokeWidth="1.54"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_6"
          d="M5.49805 18.3937C5.76573 18.0846 6.09228 17.8319 6.45863 17.6504C6.82499 17.4688 7.22383 17.362 7.63189 17.3362C8.03995 17.3104 8.44906 17.3661 8.83537 17.5001C9.22167 17.634 9.57744 17.8436 9.88192 18.1165C10.1548 18.421 10.3644 18.7767 10.4983 19.163C10.6323 19.5493 10.688 19.9584 10.6622 20.3665C10.6364 20.7746 10.5296 21.1734 10.348 21.5398C10.1665 21.9061 9.91379 22.2327 9.60472 22.5003C7.26392 24.8411 3.20859 24.7898 3.20859 24.7898C3.20859 24.7898 3.15725 20.7345 5.49805 18.3937Z"
          stroke="#0068FF"
          strokeWidth="1.54"
          strokeMiterlimit="10"
        />
        <path
          id="Vector 156"
          d="M12.889 3.01001L10.689 5.21001"
          stroke="#0068FF"
          strokeWidth="1.54"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          id="Vector 158"
          d="M24.9905 15.1099L22.7905 17.3099"
          stroke="#0068FF"
          strokeWidth="1.54"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          id="Vector 159"
          d="M24.9905 19.51L22.7905 21.71"
          stroke="#0068FF"
          strokeWidth="1.54"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          id="Vector 157"
          d="M8.49053 3.01001L6.29053 5.21001"
          stroke="#0068FF"
          strokeWidth="1.54"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};

export default IconRocket3;
